import { render } from "./FormBuilder.vue?vue&type=template&id=0724c82e&scoped=true"
import script from "./FormBuilder.vue?vue&type=script&lang=js"
export * from "./FormBuilder.vue?vue&type=script&lang=js"

import "./FormBuilder.vue?vue&type=style&index=0&id=0724c82e&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0724c82e"]])

export default __exports__